<eds-panel theme="dark" [edsSpacing]="'none'">
  <div edsGrid>
    <div edsRow>
      <div edsCol>
        <!-- breadcrumbs  area -->
        <eds-breadcrumbs [items]="breadcrumbs" theme="dark"> </eds-breadcrumbs>
      </div>
    </div>
  </div>
</eds-panel>

<ft-fund-filters
  edsSpacing="lg"
  [componentConfiguration]="componentConfiguration"
  [menu]="menu"
></ft-fund-filters>

<div class="ppss">
  <div edsGrid>
    <ng-container>
      <div edsRow>
        <div edsCol edsPadding edsPaddingTop="xxl">
          <ng-container *ngIf="canShowResults; else signIn">
            <div
              edsFlexbox
              alignItems="center"
              justifyContent="space-between"
              [edsSpacing]="(isHandheld$ | async) ? 'md' : 'lg'"
              *ngIf="numberofFilteredData !== 0"
              id="ppssScrollPosition"
            >
              <!-- Showing X of Y -->
              <p edsSpacing="none">
                {{ "products.ppss-listing-shows" | translate }}
                <b>{{ numberofFilteredData }}</b>
                {{ "products.ppss-listing-of" | translate }}
                <b>{{ totalNumberOfData }}</b>
                {{ "products.ppss-listing-items" | translate }}
              </p>
              <!-- / Showing X of Y -->
              <!-- Dropdown for top-->
              <eds-dropdown
                class="print-hidden"
                ariaLabel="Dropdown"
                [id]="'ItemsPerPageTopDD'"
                [label]="'products.items-per-page' | translate"
                [items]="itemsPerPageOption"
                [preselectedValue]="pageSize"
                (dropdownChange)="onDropdownChange($event)"
                edsPadding
                edsPaddingLeft="none"
              ></eds-dropdown>
            </div>
            <ng-container *ngIf="performanceStatusCaveat">
              <eds-proximal
                edsSpacing="lg"
                edsPadding
                edsPaddingBottom="sm"
                [placement]="performanceStatusCaveat"
              ></eds-proximal>
              <br />
            </ng-container>
            <eds-proximal
              edsSpacing="lg"
              [placement]="placementTop"
            ></eds-proximal>

            <ft-ppss-performance
              *ngIf="showTabContent['PERFORMANCE'] && hidePrformanceTabHeading"
              [active]="selected === 'PERFORMANCE'"
              [isHandheld]="isHandheld$ | async"
            >
            </ft-ppss-performance>

            <eds-tabs [followFocus]="true" [isNavigation]="true">
              <eds-tab
                *ngIf="tabs.showPerformance && !hidePrformanceTabHeading"
                [heading]="'products.performance-tab' | translate"
                [active]="currentTable === 'PERFORMANCE'"
                (selected)="onSelected('PERFORMANCE')"
              >
                <ft-ppss-performance
                  *ngIf="showTabContent['PERFORMANCE']"
                  [active]="selected === 'PERFORMANCE'"
                  [isHandheld]="isHandheld$ | async"
                >
                </ft-ppss-performance>
              </eds-tab>
              <!-- Fund Identifiers Start -->
              <eds-tab
                *ngIf="tabs.showFundIdentifiers"
                [heading]="'products.fundIdentifiers-tab' | translate"
                [active]="currentTable === 'FUNDIDENTIFIERS'"
                (selected)="onSelected('FUNDIDENTIFIERS')"
              >
                <ft-ppss-fundIdentifiers
                  *ngIf="showTabContent['FUNDIDENTIFIERS']"
                  [active]="selected === 'FUNDIDENTIFIERS'"
                  [isHandheld]="isHandheld$ | async"
                ></ft-ppss-fundIdentifiers>
              </eds-tab>
              <eds-tab
                *ngIf="tabs.showYield"
                [heading]="yieldTabName | translate"
                [active]="currentTable === 'YIELD'"
                (selected)="onSelected('YIELD')"
              >
                <ft-ppss-yields
                  *ngIf="showTabContent['YIELD']"
                  [active]="selected === 'YIELD'"
                  [isHandheld]="isHandheld$ | async"
                ></ft-ppss-yields>
              </eds-tab>
              <eds-tab
                *ngIf="tabs.showRatings"
                [heading]="'products.ratings-tab' | translate"
                [active]="currentTable === 'RATINGS'"
                (selected)="onSelected('RATINGS')"
              >
                <ft-ppss-ratings
                  *ngIf="showTabContent['RATINGS']"
                  [active]="selected === 'RATINGS'"
                  [isHandheld]="isHandheld$ | async"
                ></ft-ppss-ratings>
              </eds-tab>
            </eds-tabs>
            <!--hide pagination and dropdown-->
            <div
              class="print-hidden"
              edsFlexbox
              alignItems="center"
              justifyContent="space-between"
              [edsSpacing]="'lg'"
              *ngIf="numberofFilteredData !== 0"
            >
              <div edsSpacing="none">
                <eds-pagination
                  [prevPageText]="'products.previous' | translate"
                  [nextPageText]="'products.next' | translate"
                  [pages]="numberOfPages$ | async"
                  (pageChanged)="onPageChanged($event)"
                ></eds-pagination>
              </div>
              <!-- Dropdown for Bottom-->
              <eds-dropdown
                *ngIf="(isHandheld$ | async) !== true"
                ariaLabel="Dropdown"
                [id]="'ItemsPerPageBottomDD'"
                [label]="'products.items-per-page' | translate"
                [items]="itemsPerPageBottomOption"
                [preselectedValue]="pageSize"
                (dropdownChange)="onDropdownChange($event)"
                edsPadding
                edsPaddingLeft="none"
                edsPaddingTop="lg"
              ></eds-dropdown>
            </div>
          </ng-container>
        </div>
      </div>
      <!-- / Dropdown -->
    </ng-container>
  </div>
</div>

<ng-template #signIn>
  <ft-sign-in
    [inputParameters]="{
      skin: 'Basic 2 Columns',
      legacy: false,
      signOut: false
    }"
  ></ft-sign-in>
</ng-template>
